import Swiper from "swiper";



/* ------------------------------------ swiper type one------------------------------*/
const buildSwiperWithNav = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-ones-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideOnes = document.querySelectorAll(".half-image-slide-ones");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideOnes.forEach((slider, i) => buildSwiperWithNav(slider, i));
});


/* ------------------------------------ swiper type two------------------------------*/
const buildSwiperTwo = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-twos-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideTwos = document.querySelectorAll(".half-image-slide-twos");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideTwos.forEach((slider, i) => buildSwiperTwo(slider, i));
});


/* ------------------------------------ swiper type three------------------------------*/

const buildSwiperThree = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-threes-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideThree = document.querySelectorAll(".half-image-slide-threes");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideThree.forEach((slider, i) => buildSwiperThree(slider, i));
});


/* ------------------------------------ swiper type four------------------------------*/
const buildSwiperfour = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-fours-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideThree = document.querySelectorAll(".half-image-slide-fours");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideThree.forEach((slider, i) => buildSwiperfour(slider, i));
});



/* ------------------------------------ swiper type five------------------------------*/
const buildSwiperFive = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-fives-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideFive = document.querySelectorAll(".half-image-slide-fives");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideFive.forEach((slider, i) => buildSwiperFive(slider, i));
});



/* ------------------------------------ swiper type six------------------------------*/
const buildSwiperSix = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-sixs-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideSix = document.querySelectorAll(".half-image-slide-sixs");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideSix.forEach((slider, i) => buildSwiperSix(slider, i));
});


/* ------------------------------------ swiper type seven------------------------------*/
const buildSwiperSeven = (sliderElm, index) => {
  const uniqueClass = `half-image-slide-sevens-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.swiper-button-next');
  const prevButton = sliderElm.querySelector('.swiper-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const halfImageSlideSeven = document.querySelectorAll(".half-image-slide-sevens");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  halfImageSlideSeven.forEach((slider, i) => buildSwiperSeven(slider, i));
});
